import { useTranslation } from 'react-i18next';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/4f7d6597-d6a3-40b8-88b0-a217caf35f05/a7e4a78c-6c48-49ab-bafa-90a0541799a4_Gemini_Generated_Image_q9mwpjq9mwpjq9mw.png?v=16fe0a5bf92e6b8b68d6bea908ad577f';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToFleetTab = (tabId: string) => {
    const fleetSection = document.getElementById('fleet');
    if (fleetSection) {
      fleetSection.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        const event = new CustomEvent('setFleetTab', { detail: tabId });
        window.dispatchEvent(event);
      }, 400);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-sand-100 to-sand-200 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">

          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-16 h-16 flex items-center justify-center">
                <img
                  src={LOGO_URL}
                  alt="Hopla French Riviera"
                  className="w-16 h-16 object-contain"
                />
              </div>
            </div>
            <p className="text-navy-700 text-sm leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-navy-700 hover:bg-navy-800 hover:text-white transition-colors cursor-pointer shadow-sm">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-navy-700 hover:bg-navy-800 hover:text-white transition-colors cursor-pointer shadow-sm">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-white rounded-full text-navy-700 hover:bg-navy-800 hover:text-white transition-colors cursor-pointer shadow-sm">
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-navy-800 mb-4 text-base">{t('footer.ourServices')}</h4>
            <ul className="space-y-3">
              <li>
                <a onClick={() => scrollToFleetTab('boats')} className="text-navy-600 hover:text-ocean-500 text-sm transition-colors cursor-pointer flex items-center">
                  <i className="ri-ship-line mr-2 text-ocean-500"></i>{t('footer.boatRental')}
                </a>
              </li>
              <li>
                <a onClick={() => scrollToFleetTab('cars')} className="text-navy-600 hover:text-ocean-500 text-sm transition-colors cursor-pointer flex items-center">
                  <i className="ri-roadster-line mr-2 text-ocean-500"></i>{t('footer.carRental')}
                </a>
              </li>
              <li>
                <a onClick={() => scrollToFleetTab('campers')} className="text-navy-600 hover:text-ocean-500 text-sm transition-colors cursor-pointer flex items-center">
                  <i className="ri-caravan-line mr-2 text-ocean-500"></i>{t('footer.camperRental')}
                </a>
              </li>
              <li>
                <a href="#faq" className="text-navy-600 hover:text-ocean-500 text-sm transition-colors cursor-pointer flex items-center">
                  <i className="ri-question-line mr-2 text-ocean-500"></i>FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Destinations */}
          <div>
            <h4 className="font-semibold text-navy-800 mb-4 text-base">{t('footer.destinationsTitle')}</h4>
            <ul className="space-y-3">
              {['Hyères & Îles d\'Or', 'Porquerolles', 'Port-Cros', 'Saint-Tropez', 'Gorges du Verdon', 'Cannes & Nice'].map((dest) => (
                <li key={dest}>
                  <span className="text-navy-600 text-sm flex items-center">
                    <i className="ri-map-pin-2-line mr-2 text-coral-500 text-xs"></i>
                    {dest}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-navy-800 mb-4 text-base">{t('footer.contactUs')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-navy-600 text-sm">
                <i className="ri-map-pin-line mr-2 mt-0.5 text-ocean-500"></i>
                <span>{t('contact.homePort')}: Hyères<br />French Riviera</span>
              </li>
              <li className="flex items-center text-navy-600 text-sm">
                <i className="ri-phone-line mr-2 text-ocean-500"></i>
                <span>+33 7 65 73 03 33</span>
              </li>
              <li className="flex items-center text-navy-600 text-sm">
                <i className="ri-mail-line mr-2 text-ocean-500"></i>
                <span>contact@hoplafrenchriviera.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-sand-300 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-navy-600 text-sm">
              {t('footer.copyright')}
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-navy-500 hover:text-ocean-500 text-sm transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
